<template>
	<AppDialog :closeRight="'-10'" :closeTop="'-30'" dialogName="CreateWorkspaceDialog" width="500">
		<Col class="dialog-content rounded flex-centerize px-9 py-4">
			<Row class="title-text mb-6">Create new workspace</Row>
			<SignupTextField
				class="width-100"
				autofocus
				type="text"
				single-line
				v-model="name"
				iconName="briefcase"
				:rules="nameRules"
				label="Workspace name"
				placeholder="Workspace name"
			/>
			<SignupSelectField
				class="width-100"
				label="Company size"
				v-model="companySize"
				:rules="requiredRules"
				iconName="shared-inbox"
				:items="companySizeItems"
				placeholder="Select company size"
			/>
			<AnemicButton :disabled="isButtonDisabled" :loading="isLoading" @click="createAccount" class="pa-0 create-button mt-12" tile>
				Create
			</AnemicButton>
		</Col>
	</AppDialog>
</template>
<script>
import { mapActions } from 'vuex';
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import SignupTextField from '@/views/userRegistration/components/SignupTextField.vue';
import SignupSelectField from '@/views/userRegistration/components/SignupSelectField.vue';
import { COMPANY_SIZE } from '@/views/userRegistration/helpers/userRegistration.const.js';
import UserRegistrationService from '@/views/userRegistration/helpers/UserRegistrationService.js';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
export default {
	name: 'CreateWorkspaceDialog',
	components: { AppDialog, SignupTextField, SignupSelectField },
	props: {
		dialogPromiseHandlers: { type: Object },
	},
	computed: {
		isButtonDisabled() {
			return this.name?.length < 2 || !this.companySize || this.isLoading;
		},
	},
	methods: {
		...mapActions(['createWorkspace']), //circular dependency
		close() {
			this.dialogPromiseHandlers.resolve();
			AppDialogManagerService.closeCurrentDialog();
		},
		async createAccount() {
			this.isLoading = true;
			try {
				await this.createWorkspace({ name: this.name, companySize: this.companySize });
				this.$toast.success('Workspace created successfully');
			} catch {
				this.$toast.error('Something went wrong, please try again later');
			} finally {
				this.isLoading = false;
				this.close();
			}
		},
	},
	data() {
		return {
			name: '',
			isLoading: false,
			companySize: null,
			companySizeItems: COMPANY_SIZE,
			nameRules: UserRegistrationService.getNameRules(),
			requiredRules: UserRegistrationService.getRequiredRules(),
		};
	},
};
</script>

<style scoped lang="scss">
.dialog-content {
	width: 500px;
	overflow: hidden;
	background: var(--white);
}

.rounded {
	border-radius: 10px;
}

.create-button {
	width: 122px !important;
	height: 40px !important;
	font-size: 14px !important;
	border-radius: 8px !important;
	letter-spacing: 0px !important;
	color: var(--white) !important;
	font-weight: normal !important;
	text-transform: none !important;
	background: #5858ec !important;
}
.title-text {
	font-size: 22px;
	font-weight: bold;
	color: var(--primary-font-color);
}
</style>
